import { render, staticRenderFns } from "./Reclassification.vue?vue&type=template&id=5af226ff&scoped=true&"
import script from "./Reclassification.vue?vue&type=script&lang=js&"
export * from "./Reclassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af226ff",
  null
  
)

export default component.exports